import { all, call, put, select, takeLatest } from 'redux-saga/effects';

import { getAppsflyerFromCookie } from '@dragonfruit/utils/appsflyers';

import {
  apiCheckoutBuildPending,
  apiCheckoutNeweb,
} from '@dragonfruit/services/apis';

import * as actions from '@dragonfruit/redux/purchase/checkoutNeweb';
import { showAlertBanner } from '@dragonfruit/redux/alertBanner';
import { setHasSubscription } from '@dragonfruit/redux/plans';
import { savePurchase } from '@dragonfruit/redux/purchase/paymentReceipt';

import { sendGtmEvent } from '@dragonfruit/redux/googleTagManager';
import { getDiscountCode } from '@dragonfruit/redux/discountCode';
import { paymentReceipt } from '@dragonfruit/redux/navigation';
import { getBundleContents } from '@dragonfruit/redux/plans';

import { ALERT_ERROR_THEME } from '@dragonfruit/constants/alertBannerThemes';
import { HAS_SUBSCRIPTION_PLAN } from '@dragonfruit/constants/errorCode';
import {
  PURCHASE_INITIAL_CHECKOUT,
  PRODUCT_CHECKOUT,
} from '@dragonfruit/constants/gtmEvents';
import { WEB } from '@dragonfruit/constants/platformTypes';

export function* checkoutNeweb(action) {
  const {
    paymentType,
    collectionId,
    paymentMethodId,
    invoiceInfo,
    deliveryInfo,
    gtmData: {
      //The data below comes from selectedPlan object.
      planId,
      name,
      planType,
      sellingTypes,
      questionQuota,
      currency,
      //The data below comes from paymentMethod object in the plan.
      price,
      sku,
    },
  } = action.payload;

  const discountCode = yield select(getDiscountCode);
  const bundleContents = yield select(getBundleContents);
  const appsflyerSale = getAppsflyerFromCookie();

  try {
    yield put(
      sendGtmEvent({
        eventName: PRODUCT_CHECKOUT,
        data: {
          ecommerce: {
            currencyCode: currency,
            checkout: {
              products: [
                {
                  id: sku,
                  name,
                  category: planType,
                  price,
                  quantity: 1,
                },
              ],
            },
          },
        },
      })
    );

    yield put(
      sendGtmEvent({
        eventName: PURCHASE_INITIAL_CHECKOUT,
        data: {
          content_ids: [paymentMethodId],
          content_type: sellingTypes.join('-'),
          contents: sku,
          currency,
          num_items: questionQuota,
          paymentType,
          planId,
          platform: WEB,
          value: price,
        },
      })
    );

    let commonData = {
      collectionId,
      paymentMethodId,
      paymentType,
      invoiceInfo,
      deliveryInfo,
    };

    if (discountCode) {
      commonData.code = discountCode;
    }

    if (bundleContents && bundleContents.length > 0) {
      commonData.bundleContents = bundleContents;
    }

    let buildPendingData = { ...commonData };

    if (appsflyerSale) {
      buildPendingData.appsflyerSale = appsflyerSale;
    }

    const {
      payment: { orderNumber },
    } = yield call(apiCheckoutBuildPending, buildPendingData);

    let checkoutData = { ...commonData };
    checkoutData.orderNumber = orderNumber;

    yield call(apiCheckoutNeweb, checkoutData);

    yield put(actions.checkoutNewebSuccess());

    yield put(
      savePurchase({
        orderNumber,
      })
    );

    yield put(paymentReceipt());
  } catch (error) {
    const { message, error_code } = error;

    yield put(
      showAlertBanner({
        message,
        theme: ALERT_ERROR_THEME,
      })
    );
    yield put(actions.checkoutNewebError(message));
    yield put(setHasSubscription(error_code === HAS_SUBSCRIPTION_PLAN));
  }
}

export default function*() {
  yield all([takeLatest(actions.CHECKOUT_NEWEB, checkoutNeweb)]);
}



// WEBPACK FOOTER //
// ./app/sagas/purchase/checkoutNeweb.js